import { GpsNotFixedIcon } from "@l2r-front/l2r-icons"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import * as Styled from "./GpsLocationButton.styled"

type GpsLocationButtonProps = {
    onClick?: () => void
}

export const GpsLocationButton = (props: GpsLocationButtonProps) => {
    const { onClick } = props

    const isMobile = useIsMobileDevice()

    return <Styled.Button variant="tertiary" shape="circle" outlined={false} isMobile={isMobile} onClick={onClick}>
        <GpsNotFixedIcon />
    </Styled.Button>
}
